import { render, staticRenderFns } from "./VMLogEntries.vue?vue&type=template&id=35d1448b&"
import script from "./VMLogEntries.vue?vue&type=script&lang=js&"
export * from "./VMLogEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports